module.exports = __webpack_public_path__ + "static/media/ailing-bio.708464b7.pdf";